import {
  FacebookNext,
  MailNext,
  TelegramNext,
  TwitterNext,
  WhatsappNext,
} from '@assets/icons';

export const SOCIAL_LINKS = [
  {
    name: 'WhatsApp',
    icon: WhatsappNext,
    url: (link: string) =>
      `https://wa.me/send?text=%20Aradığın%20tatil%20Setur’da%20${link}`,
  },
  {
    name: 'Facebook',
    icon: FacebookNext,
    url: (link: string) =>
      `https://www.facebook.com/sharer/sharer.php?u=${link}`,
  },
  {
    name: 'Twitter',
    icon: TwitterNext,
    url: (link: string) =>
      `https://twitter.com/intent/tweet?text=Arad%C4%B1%C4%9F%C4%B1n%20Tatil%20Setur'da&url=${link}`,
  },
  {
    name: 'Telegram',
    icon: TelegramNext,
    url: (link: string) =>
      `https://t.me/share/url?url=${link}&text=Aradığın Tatil Setur’da`,
  },
  {
    name: 'Mail',
    icon: MailNext,
    url: (link: string) =>
      `mailto:?subject=Aradığın tatil Setur’da&body=${link}`,
  },
];
